import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home,
		meta: {
			requireAuth: false,
		},
	},
	
];
		
const router = new VueRouter({
  mode:"history",
  routes, // short for routes: routes
});
export default router;
